import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { CredusButton, CredusText } from 'ui';

interface ConfirmActionProps {
  showActionConfirmation: boolean;
  setShowActionConfirmation: React.Dispatch<React.SetStateAction<boolean>>;

  loading?: boolean;
  action: (() => Promise<void>) | (() => void) | undefined;
  text: string;
}

const ConfirmAction = ({
  showActionConfirmation,
  setShowActionConfirmation,
  text,
  loading,

  action,
}: ConfirmActionProps) => {
  const handleClick = () => {
    action?.();
  };
  return (
    <Modal
      title={
        <CredusText size="md" weight="medium">
          Confirm Action
        </CredusText>
      }
      open={showActionConfirmation}
      footer=""
      onCancel={() => setShowActionConfirmation(false)}
    >
      <Container>
        <CredusText size="lg" align="center">
          {text}
        </CredusText>
        <BtnDiv>
          <CredusButton onClick={handleClick}>
            {loading ? 'Loading' : 'Yes, Continue'}
          </CredusButton>
          <CredusButton variant="secondary">Cancel</CredusButton>
        </BtnDiv>
      </Container>
    </Modal>
  );
};

export default ConfirmAction;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 16rem;
  padding: 1rem;
  box-sizing: border-box;
  border-top: 0.5px solid rgba(0, 0, 0, 0.15);
  margin-top: 1.5rem;
  gap: 1.5rem;
`;

const BtnDiv = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;
